import React, { useContext } from  'react'
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import './SkywatchProgressBar.scss'
import { useLocation, useHistory } from 'react-router-dom';
import { isMobile, BrowserView } from 'react-device-detect';
import ScheduleIcon from '@material-ui/icons/Schedule';
import FlexView from 'react-flexview/lib';
import Colors from '../../styles/colors.scss';
import LocalizationService from '../../services/LocalizationService';
import { SessionService } from '../../services/SessionService';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';

var classNames = require('classnames');


export const SkywatchClaimsProgressBar = () => {
    const location = useLocation()
    const history = useHistory()

    const isStepFinish = (stepIndex) => {
        if(stepIndex == 1 && (location.pathname == "/claim/process/info" || location.pathname == "/claim/process/hull" || location.pathname == "/claim/process/claim"))
            return true
        if(stepIndex == 2 && (location.pathname == "/claim/process/hull" || location.pathname == "/claim/process/claim"))
            return true
        if(stepIndex == 3 && (location.pathname == "/claim/process/claim"))
            return true
        return false
    }

    const selectStep = {title: `Select Policy`, active: false, finished: true, path: '/claim/process/policy'}
    const incidentStep =  {title: `Incident Info`, active: false, finished: isStepFinish(1), path: '/claim/process/info'}
    const hullStep = {title: `Equipment Info`, active: false, finished: isStepFinish(2), path: '/claim/process/hull'};
    const finalizeStep = {title: 'Claim Info', active: false, finished: isStepFinish(3), path: '/claim/process/claim'};
    let steps = [selectStep, incidentStep, hullStep, finalizeStep]
    
    const redirect = (item) => {
        if(!item.finished) return
        let path = item.path
        history.push(path)
    }
        
    const positions = () => {
        return steps.map((item, index) => ((index + 0.5) / steps.length) * 100)
    }

    const completedPercent = () => {
        let index = steps.findIndex(t => t.finished == false)

        if(index == -1) 
            index = steps.length

        if(index == steps.length)
            return 100

        let percent = (index - 0.5) * 100 / steps.length + 1
        if(isMobile)
            percent += 2
        return percent
    }

    const displayPercent = () => {
        let per = (steps.findIndex(t => t.finished == false) - 1) * 100 / (steps.length - 1)
        if(per < 0) {
            per = (steps.length) * 100 / steps.length
        }
        return Math.round(per * 100) / 100
    }

    const getTimeLeft = () => {
        switch(location.pathname) {
            case '/claim/process/policy':
                return "3min"
            case '/claim/process/info':
                return "3min"
            case '/claim/process/hull':
                return "2min"
            case '/claim/process/claim':
                return "1min"
            default:
                return "3min"
        }
    }

    return (
        <div className="skywatch-progress-bar-container margin-bottom-basic margin-top-medium">
        <BrowserView><div className="text-tiny gray">Your progress</div></BrowserView>
        <FlexView vAlignContent={'bottom'} className="space-between margin-bottom-basic margin-top-6">
            <div className="text-body bold blue ">{displayPercent()}% completed</div>
            <FlexView vAlignContent={'center'}>
                <ScheduleIcon className="tiny-icon backbuttongray" />
                <div className="text-tiny bold backbuttongray margin-left-3">{getTimeLeft()}</div>
            </FlexView>
        </FlexView>
        <ProgressBar
                percent={completedPercent()}
                stepPositions={positions()}
                unfilledBackground={Colors.bluegrey}
                filledBackground={`linear-gradient(91deg, ${Colors.blue} -6%, ${Colors.darkblue} 167%)`}>
                    {steps.map((item, index) => <Step key={index} transition="scale">
                        {({ accomplished }) => (
                            <div className={classNames('dot', {'not-finished': !item.finished})}>
                                <div onClick={() => redirect(item)} className={classNames("dot-text", "text-tiny", "blue", { "clickable": item.finished } )}>{item.title}</div>
                            </div>
                        )}
                    </Step>)}
            </ProgressBar>
        </div>
    )
}